<template>
  <div
      :class="['tl', isBusiness ? 'can-res' : 'cant-res']"
      :style="style"
      @mousedown="mousedown"
      @click="click"
      @mouseenter="mouseenter"
      @mouseup="mouseup"
      @dragenter="setDragenterRowAndIndex"
      @drop="drop"
  >
  </div>
</template>

<script>
export default {
  name: 'UnitDiv',
  props: {
    // От прода к деву тип меняется от Number к String
    rowIndex: Number,
    keyIndex: Number,
    height: String,
    rowData: Object,
    isBusiness: Boolean,
    isSelecting: Boolean,
    isSelectingRowIndex: Number
  },
  data: function () {
    return {};
  },
  computed: {
    style()  {
      return {
        height: this.height,
        backgroundImage: this.isBusiness ? '' : 'url(' + require('@/assets/verticalLine.png') + ')'
      }
    },
    isHour () {
      return true
    }
  },
  methods: {
    mousedown() {
      if (!this.isBusiness) {
        return false
      }
      this.$emit("mouse-down", this.rowIndex, this.keyIndex);
    },
    click() {
      if (!this.isBusiness) {
        return false
      }
      this.$emit("click", this.rowIndex, this.keyIndex);
    },
    mouseenter() {
      if (
          !this.isSelecting ||
          this.rowIndex != this.isSelectingRowIndex ||
          !this.isBusiness
      ) {
        return false;
      }
      this.$emit("mouse-enter", this.keyIndex);
    },
    mouseup() {
      this.$emit("mouse-up")
    },
    setDragenterRowAndIndex() {

      // console.log('setDragenterRowAndIndex', e)
      //
      // if (!this.isBusiness) {
      //   return false
      // }
      // this.$emit("set-dragenter-row-and-index", this.rowIndex, this.keyIndex);
    },
    drop (e) {



      console.log('drop',e)

      console.log({
        row: this.rowIndex,
        key: this.keyIndex,
      })

    },
  }
};
</script>

<style lang="scss" scoped>

</style>